import config from "../config";

const getters = {

    windowHeight(state) {
        return state.windowHeight;
    },
    /*
    * isWindowXS работает только для моб экрана, остальные геттеры по нарастанию
    * */
    isWindowXS(state) {
        return state.windowWidth < config.WIDTH_SM;
    },
    isWindowSM(state) {
        return state.windowWidth >= config.WIDTH_SM;
    },
    isWindowMD(state) {
        return state.windowWidth >= config.WIDTH_MD;
    },
    isWindowLG(state) {
        return state.windowWidth >= config.WIDTH_LG;
    },
    isWindowXL(state) {
        return state.windowWidth >= config.WIDTH_XL;
    },

    /*
    * Предзаказ: максимальная (Y-m-d) первая дата доставки среди товаров корзины, купленных по предзаказу.
    * null - в корзине нет предзаказных товаров, ограничений по дате нет
    * */
    basketPreorderDeliveryFrom(state) {
        const dates = (state.session?.basket || [])
            .map(item => item.product?.PREORDER_DELIVERY_FROM)
            .filter(Boolean);
        if (!dates.length) return null;
        return dates.reduce((max, date) => (date > max ? date : max));
    },

    /*
    * Предзаказ: общее количество единиц предзаказных товаров в корзине = количество билетов
    * (по одному билету на каждую единицу, см. api/entities/Ticket.php)
    * */
    basketPreorderQuantity(state) {
        return (state.session?.basket || [])
            .filter(item => !item.IS_TICKET && item.product?.PREORDER_DELIVERY_FROM)
            .reduce((sum, item) => sum + Number(item.AMOUNT || 0), 0);
    },

    currentLanguage(state) {
        return state.languages.find(el=>el.code===state.currentLanguageCode);
    },
    currentCity(state) {
        let city = state.currentCity;
        if (!city) {
            city = localStorage.getItem('city');
            if (city) {
                state.currentCity = city;
            } else {
                city = state.common.geo.cityName;
                if (city) {
                    state.currentCity = city;
                }
            }
        }
        return city;
    }
};
export default getters;
